import React, { useEffect, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import CreateIcon from "@mui/icons-material/Create";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { fetchAllUsers } from "../../actions/PrivilegeAction";
import VpnKeyIcon from "@mui/icons-material/VpnKey";
import PermissionModel from "../Model/PermissionModel";
import EditUserModel from "../Model/EditUserModel";
import CreateUserModel from "../Model/CreateUserModel";
import { newPrivilege, deleteUser } from "../../actions/PrivilegeAction";
import DeleteUserModel from "../Model/DeleteUserModel";
import { createNewUser, updateExistUser } from "../../actions/PrivilegeAction";
import {
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  Grid,
  LinearProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { fetchUserById } from "../../actions/UserAction";

const classes = {
  table: {
    minWidth: 650,
  },
  addIcon: {
    color: "#05234A",
    border: "solid 1px #05234A",
    padding: "2px",
    margin: "5px",
    borderRadius: "100%",
  },
  textColor: {
    color: "#05234A",
    fontWeight: "bold",
  },
};
const dropDownLimit = 8;
function Privilege() {
  const [userList, setUserList] = useState([]);
  const [begin, setBegin] = useState(0);
  const [end, setEnd] = useState(0);
  const [newArrayList, setNewArrayList] = useState(0);
  const [privilegeOpen, setOpen] = useState(false);
  const [userEditOpen, setUserEditOpen] = useState(false);
  const [userCreateOpen, setUserCreateOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState("");
  const [permissions, setPermissions] = useState({});
  const [deleteUserOpen, setDeleteUserOpen] = useState();
  const [updateUser, setUpdateUser] = useState({});
  const [lineProgress, setLineProgress] = useState(false);
  const [createdUser, setCreatedUser] = useState({
    firstName: "",
    lastName: "",
    userName: "",
    email: "",
    password: "",
    Cpassword: "",
    mobile: "",
    role: "",
  });

  const reFetchingUsers = async () => {
    const routePointList = fetchAllUsers((res) => {
      setUserList(res);
      setLineProgress(false);
    });
    await routePointList();
  };
  useEffect(() => {
    setLineProgress(true);
    const fetchingFunction = async () => {
      const userList = fetchAllUsers((res) => {
        setUserList(res);
        setLineProgress(false);
      });
      await userList();
    };
    fetchingFunction();
  }, []);

  const handleBack = () => {
    setBegin(begin - dropDownLimit <= 0 ? 0 : begin - dropDownLimit);
    setEnd(begin < end - dropDownLimit ? userList.length : begin);
  };
  const handleForward = () => {
    setBegin(
      begin + dropDownLimit < userList.length ? begin + dropDownLimit : 0
    );
    setEnd(
      userList.length < end + dropDownLimit
        ? userList.length
        : end + dropDownLimit
    );
  };
  const handleDelete = async () => {
    setLineProgress(true);
    const deleteSelectUser = deleteUser(selectedUser.id, () =>
      reFetchingUsers()
    );
    deleteSelectUser();
  };
  const handleClose = () => {
    setOpen(!privilegeOpen);
    setPermissions({
      approve_schedule: selectedUser.permission?.includes("approve_schedule")
        ? true
        : false,
      delete_schedule: selectedUser.permission?.includes("delete_schedule")
        ? true
        : false,
      own_schedule: selectedUser.permission?.includes("own_schedule")
        ? true
        : false,
      view_schedule: selectedUser.permission?.includes("view_schedule")
        ? true
        : false,
      create_schedule: selectedUser.permission?.includes("create_schedule")
        ? true
        : false,
      pay_schedule: selectedUser.permission?.includes("pay_schedule")
        ? true
        : false,
      delete_users: selectedUser.permission?.includes("delete_users")
        ? true
        : false,
      manage_users: selectedUser.permission?.includes("manage_users")
        ? true
        : false,
      own_profile:
        selectedUser.permission?.includes("own_profile") == true ? true : false,
      view_users: selectedUser.permission?.includes("view_users")
        ? true
        : false,
    });
  };
  const addArray = (permissions) => {
    const permissionArray = [];
    if (permissions.approve_schedule) {
      permissionArray.push("approve_schedule");
    }
    if (permissions.delete_schedule) {
      permissionArray.push("delete_schedule");
    }
    if (permissions.own_schedule) {
      permissionArray.push("own_schedule");
    }
    if (permissions.view_schedule) {
      permissionArray.push("view_schedule");
    }
    if (permissions.create_schedule) {
      permissionArray.push("create_schedule");
    }
    if (permissions.pay_schedule) {
      permissionArray.push("pay_schedule");
    }
    if (permissions.delete_users) {
      permissionArray.push("delete_users");
    }
    if (permissions.manage_users) {
      permissionArray.push("manage_users");
    }
    if (permissions.own_profile) {
      permissionArray.push("own_profile");
    }
    if (permissions.view_users) {
      permissionArray.push("view_users");
    }
    return permissionArray;
  };
  const handlePrivilege = async () => {
    const newPrev = {
      userId: selectedUser.id,
      groupName: addArray(permissions),
    };
    setLineProgress(true);
    const privilege = newPrivilege(newPrev, () => reFetchingUsers());
    await privilege();
    setOpen(!privilegeOpen);
  };

  const handleCloseEditUser = () => {
    setUserEditOpen(!userEditOpen);
  };
  const handleEdit = async (row) => {
    setUserEditOpen(!userEditOpen);
    setSelectedUser(row);
    const user = fetchUserById(row.id, (res) => {
      setUpdateUser({
        id: res.id,
        firstName: res.firstName ? res.firstName : "",
        lastName: res.lastName ? res.lastName : "",
        email: res.email ? res.email : "",
        mobile: res.mobile ? res.mobile : "",
        permission: res.permission ? res.permission : "",
        profileImage: res.profileImage ? res.profileImage : "",
        role: res.role ? res.role : "",
        userName: res.userName ? res.userName : "",
      });
    });
    await user();
  };
  const handleUpdate = async () => {
    setLineProgress(true);
    const update = updateExistUser(updateUser, () => reFetchingUsers());
    await update();
    // setLineProgress(false)
    setUserEditOpen(!userEditOpen);
  };
  const handleCreate = async () => {
    delete createdUser.Cpassword;
    setLineProgress(true);
    const create = createNewUser(createdUser, () => reFetchingUsers());
    await create();
    setUserCreateOpen(!userCreateOpen);
  };
  const handleCreateClose = () => {
    setCreatedUser({
      firstName: "",
      lastName: "",
      userName: "",
      email: "",
      password: "",
      Cpassword: "",
      mobile: "",
      role: "",
    });
    setUserCreateOpen(!userCreateOpen);
  };
  return (
    <div>
      <Card style={{ border: "#083979 1px solid", borderRadius: "15px" }}>
        <CardContent>
          <Grid container spacing={1} style={{ justifyContent: "flex-end" }}>
            <Grid item style={{ display: "flex" }}>
              <Grid item>
                <Button onClick={() => setUserCreateOpen(!userCreateOpen)}>
                  <AddIcon fontSize="large" style={classes.addIcon} />
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </CardContent>
        <TableContainer component={Paper}>
          <Table style={classes.table} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell align="left">Image</TableCell>
                <TableCell align="left">User Name</TableCell>
                <TableCell align="left">Name</TableCell>
                <TableCell align="left">Email</TableCell>
                <TableCell align="left">Mobile No</TableCell>
                <TableCell align="center">Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {lineProgress && (
                <Box
                  sx={{
                    width: userList.length == 0 ? "660%" : "1245%",
                  }}
                >
                  <LinearProgress />
                </Box>
              )}
              {userList.length >= 1 &&
                userList.map((row) => (
                  <TableRow key={row.id}>
                    <TableCell align="left">
                      <Avatar alt="Remy Sharp" src={row.profileImage} />
                    </TableCell>
                    <TableCell style={classes.textColor} align="left">
                      {row.userName}
                    </TableCell>
                    <TableCell style={classes.textColor} align="left">
                      {row.firstName} {row.lastName}
                    </TableCell>
                    <TableCell style={classes.textColor} align="left">
                      {row.email}
                    </TableCell>
                    <TableCell style={classes.textColor} align="left">
                      {row?.mobile ? row.mobile : "N/A"}
                    </TableCell>
                    <TableCell align="left">
                      <Button
                        onClick={() =>
                          setOpen(!privilegeOpen, setSelectedUser(row))
                        }
                      >
                        <VpnKeyIcon />
                      </Button>
                      <Button
                        style={{ color: "#E1BE43", borderRadius: "100%" }}
                        onClick={() => handleEdit(row)}
                      >
                        <CreateIcon />
                      </Button>
                      <Button
                        style={{ color: "#EC6767", borderRadius: "100%" }}
                        onClick={() =>
                          setDeleteUserOpen(
                            !deleteUserOpen,
                            setSelectedUser(row)
                          )
                        }
                      >
                        <DeleteOutlineIcon />
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
        <Box
          display="flex"
          justifyContent="center"
          mt={3}
          style={{ margin: "10px" }}
        >
          <Grid container justifyContent="center" alignItems="center">
            <Button
              disabled={begin == 0}
              style={{
                border: "1px solid #05234A",
                borderRadius: "10px",
                margin: "2px",
              }}
            >
              <ArrowBackIosIcon onClick={handleBack} />
            </Button>
            <Button
              disabled={end == newArrayList}
              style={{
                border: "1px solid #05234A",
                borderRadius: "10px",
                margin: "2px",
              }}
            >
              <ArrowForwardIosIcon onClick={handleForward} />
            </Button>
          </Grid>
        </Box>
      </Card>
      <PermissionModel
        user={selectedUser}
        open={privilegeOpen}
        permissions={permissions}
        setPermissions={setPermissions}
        handleClose={handleClose}
        handleAgree={handlePrivilege}
      />
      <EditUserModel
        user={updateUser}
        setUpdateUser={setUpdateUser}
        open={userEditOpen}
        handleClose={handleCloseEditUser}
        handleAgree={handleUpdate}
      />
      <CreateUserModel
        open={userCreateOpen}
        handleClose={handleCreateClose}
        createdUser={createdUser}
        setCreatedUser={setCreatedUser}
        handleAgree={handleCreate}
      />
      <DeleteUserModel
        open={deleteUserOpen}
        handleClose={() => setDeleteUserOpen(!deleteUserOpen)}
        handleAgree={handleDelete}
        user={selectedUser}
      />
    </div>
  );
}

export default Privilege;
